module.exports = __webpack_public_path__ + "img/Signout.2b5999b1.svg";